import React from "react";
import WorldMoodMap from "./WorldMoodMap";
import { ThemeProvider } from "./design-system/theme/ThemeProvider";

function App() {
  return (
    <ThemeProvider>
      <WorldMoodMap />
    </ThemeProvider>
  );
}

export default App;
